import commonConfig from 'config/commonConfig';

(function () {
  //The Universal Tag alllows you to override certain behaviors via a global object named "window.utag_cfg_ovrd".
  //To override the automatic page tracking add this line to your page prior to loading utag.js
  window.utag_cfg_ovrd = {noview: true};
  window.utag_data = {site_type: 'single_page'};
  const countryCode = 'au';
  if (commonConfig.tealium.toUseTealium && countryCode) {
    var hostname = window.location.hostname || '';
    var isProd =
      -1 !== hostname.indexOf('www.hsbc.com.au') ||
      // -1 !== hostname.indexOf(commonConfig.tealium.prodEnvDesc);
      console.log('isProd======', isProd);
    //whether only one desc represent prod env?
    window.tealium = {
      market: countryCode.toLowerCase() + commonConfig.tealium.marketSuffix,
      environment: isProd ? 'prod' : 'dev',
      titlePrefix: 'SFP-',
      urlPrefix: '/sfp/',
      namePrefix: 'SG-WP-',
    };

    // --------------------------
    var HSBC = {};
    window.HSBC = window.HSBC || {};
    HSBC.SITE = HSBC.SITE || {};
    HSBC.PAGE = HSBC.PAGE || {};
    HSBC.EXT = HSBC.EXT || {};
    HSBC.LOG = HSBC.LOG || {};
    HSBC.DCS = HSBC.DCS || {};

    (function (a, b, c, d) {
      a =
        '//tags.tiqcdn.com/utag/hsbc/' +
        window.tealium.market +
        '/' +
        window.tealium.environment +
        '/utag.sync.js';
      b = document;
      c = 'script';
      d = b.createElement(c);
      d.src = a;
      a = b.getElementsByTagName('head')[0];
      a.appendChild(d);
    })();
    (function (a, b, c, d) {
      a =
        '//tags.tiqcdn.com/utag/hsbc/' +
        window.tealium.market +
        '/' +
        window.tealium.environment +
        '/utag.js';
      b = document;
      c = 'script';
      d = b.createElement(c);
      d.src = a;
      d.type = 'text/java' + c;
      d.async = true;
      a = b.getElementsByTagName(c)[0];
      a.parentNode.insertBefore(d, a);
    })();
  }
})();
